'use strict';
(function() {
	if (!document.querySelector('body').classList.contains('isEditing')) {
		document.addEventListener('DOMContentLoaded', function(event) {

			// switch between toc and content (mobile only)
			// TODO: functionality without JS
			var containerToggleElements = document.querySelectorAll('.guide-tabbar button');
			for (var i = 0; i < containerToggleElements.length; i++) {
				containerToggleElements[i].addEventListener('click', function(e) {
					for (var i = 0; i < containerToggleElements.length; i++) {
						containerToggleElements[i].setAttribute('aria-selected','false');
					}
					e.target.setAttribute('aria-selected','true');
					switch(e.target.dataset.toggle) {
						case 'table_of_contents':
							document.querySelector('#guide-toc-panel').classList.remove('mobile-hidden');
							document.querySelector('#guide-page-panel').classList.add('mobile-hidden');
							document.querySelector('.guide-header').classList.add('mobile-sr-only');
							break;
						case 'content':
							document.querySelector('#guide-toc-panel').classList.add('mobile-hidden');
							document.querySelector('#guide-page-panel').classList.remove('mobile-hidden');
							document.querySelector('.guide-header').classList.remove('mobile-sr-only');
							break;
					}
				});
			}

			// search form
			var searchFormElement = document.querySelector('.guide .sidebar form');
			if (searchFormElement) {
				var searchInput = searchFormElement.querySelector('input[type="text"]');
				searchFormElement.addEventListener('submit', function(e) {
					e.preventDefault();
					window.location.href = searchFormElement.dataset.action + '+' + searchInput.value;
				});
			}

		});
	}

})();
